import { ref } from 'vue'

export const usePlanValues = () => {
  const selectPlan = ref([
    '自宅療養',
    '入院',
    '指示事項'
  ])
  return {
    selectPlan
  }
}
